import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ReactiveFormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { BrowserModule } from "@angular/platform-browser";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";

import { ConfirmationService } from "primeng/api";
import { ConfirmDialogModule } from "primeng/confirmdialog";
import { DynamicDialogModule } from "primeng/dynamicdialog";
import { DialogModule } from "primeng/dialog";
import { CalendarModule } from "primeng/calendar";
import { TableModule } from "primeng/table";
import { ButtonModule } from "primeng/button";
import { MultiSelectModule } from "primeng/multiselect";
import { DropdownModule } from "primeng/dropdown";
import { InputNumberModule } from "primeng/inputnumber";
import { RadioButtonModule } from "primeng/radiobutton";
import { AccordionModule } from "primeng/accordion";
import { FileUploadModule } from "primeng/fileupload";
import { CheckboxModule } from "primeng/checkbox";
import { ColorPickerModule } from "primeng/colorpicker";

import { AppSharedModule } from "../../shared/app-shared.module";
import { PersonSelectorModule } from "../personselector/personselector.module";
import { SchoolselectorModule } from "../schoolselector/schoolselector.module";
import { ListboxModule } from "primeng/listbox";

import { AdminSetupComponent } from "./index";

//New version
import { ClassAttendanceExcuseSetupComponent } from "./class-attendance-excuse-setup/class-attendance-excuse-setup.component";
import { AdminSetupAddAttendanceExcuseComponent } from "./class-attendance-excuse-setup/admin-setup-add-attendance-excuse/admin-setup-add-attendance-excuse.component";
import { AdminSetupEditAttendanceExcuseComponent } from "./class-attendance-excuse-setup/admin-setup-edit-attendance-excuse/admin-setup-edit-attendance-excuse.component";
import { DataService_ClassAttendanceExcuseSetup } from "./class-attendance-excuse-setup/shared/data.service";

// CommunicationMaintenance
import { CommunicationMaintenanceComponent } from "./communicationmaintenance/communicationmaintenance.component";
import { AddNotificationComponent } from "./communicationmaintenance/addnotification/addnotification.component";

// ** Service For Above Screens **
import { AdminSetupService } from "./services/adminsetup.service";

// AlertMaintenance
import { AlertMaintenanceComponent } from "./alertmaintenance/alertmaintenance.component";
import { AddBroadcastAlertComponent } from "./alertmaintenance/addbroadcastalert/addbroadcastalert.component";
import { EditBroadcastAlertComponent } from "./alertmaintenance/editbroadcastalert/editbroadcastalert.component";
import { EditSpecialAlertComponent } from "./alertmaintenance/editspecialalert/editspecialalert.component";
import { AddEditEventAlertComponent } from "./alertmaintenance/addediteventalert/addediteventalert.component";
import { AddEditIncidentAlertComponent } from "./alertmaintenance/addeditincidentalert/addeditincidentalert.component";
import { DataService_AlertMaintenance } from "./alertmaintenance/shared/data.service";

// ActionMaintenance
import { ActionMaintenanceComponent } from "./actionmaintenance/actionmaintenance.component";
import { AddEditActionComponent } from "./actionmaintenance/addeditaction/addeditaction.component";
import { DataService_ActionMaintenance } from "./actionmaintenance/shared/data.service";

// ActionMaintenanceSBT
import { ActionMaintenanceSBTComponent } from "./actionmaintenancesbt/actionmaintenancesbt.component";
import { AddEditActionSBTComponent } from "./actionmaintenancesbt/addeditactionsbt/addeditactionsbt.component";
import { DataService_ActionMaintenanceSBT } from "./actionmaintenancesbt/shared/data.service";

// InfractionMaintenance
import { InfractionMaintenanceComponent } from "./infractionmaintenance/infractionmaintenance.component";
import { AddEditInfractionComponent } from "./infractionmaintenance/addeditinfraction/addeditinfraction.component";
import { DataService_InfractionMaintenance } from "./infractionmaintenance/shared/data.service";

// InfractionMaintenance
import { InfractionMaintenanceSBTComponent } from "./infractionmaintenancesbt/infractionmaintenancesbt.component";
import { AddEditInfractionSBTComponent } from "./infractionmaintenancesbt/addeditinfractionsbt/addeditinfractionsbt.component";
import { DataService_InfractionMaintenanceSBT } from "./infractionmaintenancesbt/shared/data.service";

// SoundMaintenance
import { SoundMaintenanceComponent } from "./soundmaintenance/soundmaintenance.component";
import { SchoolOrDistrictComponent } from "./soundmaintenance/school-or-district/school-or-district.component";
import { DataService_SoundMaintenance } from "./soundmaintenance/shared/data.service";
import { RecordSoundComponent } from "./soundmaintenance/record-sound/record-sound.component";
import { EditSoundComponent } from "./soundmaintenance/edit-sound/edit-sound.component";

//Calendar Maintenance
import { CalendarmaintenanceComponent } from "./calendarmaintenance/calendarmaintenance.component";
import { CalendarEntryComponent } from "./calendarmaintenance/calendar-entry/calendar-entry.component";
import { AdjustMenuComponent } from "./calendarmaintenance/adjust-menu/adjust-menu.component";
import { ChangeMultipleComponent } from "./calendarmaintenance/change-multiple/change-multiple.component";

//New Excuse Maintenance
import { ExcuseSetupComponent } from "./excuse-setup/excuse-setup.component";
import { AdminSetupAddExcuseComponent } from "./excuse-setup/admin-setup-add-excuse/admin-setup-add-excuse.component";
import { AdminSetupEditExcuseComponent } from "./excuse-setup/admin-setup-edit-excuse/admin-setup-edit-excuse.component";
import { DataService_ExcuseSetup } from "./excuse-setup/shared/data.service";

//New Homeroom Maintenance
import { HomeroomSetupComponent } from "./homeroom-setup/homeroom-setup.component";
import { AdminSetupEditHomeroomComponent } from "./homeroom-setup/admin-setup-edit-homeroom/admin-setup-edit-homeroom.component";
import { DataService_HomeroomSetup } from "./homeroom-setup/shared/data.service";

//New School Day Maintenance
import { SchoolDaySetupComponent } from "./school-day-setup/school-day-setup.component";
import { AdminSetupEditSchoolDayComponent } from "./school-day-setup/admin-setup-edit-school-day/admin-setup-edit-school-day.component";
import { DataService_SchoolDaySetup } from "./school-day-setup/shared/data.service";

//New Time Scan Type Maintenance
import { TimeScanTypeSetupComponent } from "./time-scan-type-setup/time-scan-type-setup.component";
import { AdminSetupAddTimeScanTypeComponent } from "./time-scan-type-setup/admin-setup-add-time-scan-type/admin-setup-add-time-scan-type.component";
import { AdminSetupEditTimeScanTypeComponent } from "./time-scan-type-setup/admin-setup-edit-time-scan-type/admin-setup-edit-time-scan-type.component";
import { DataService_TimeScanTypeSetup } from "./time-scan-type-setup/shared/data.service";
import { AcademySetupComponent } from "./academy-setup/academy-setup.component";
import { SchoolAddAcademyComponent } from "./academy-setup/school-add-academy/school-add-academy.component";
import { SchoolEditAcademyComponent } from "./academy-setup/school-edit-academy/school-edit-academy.component";
import { DataService_AcademySetup } from "./academy-setup/shared/data.service";

//New Bell Schedule
import { BellScheduleSetupComponent } from "./bell-schedule-setup/bell-schedule-setup.component";
import { SchoolAddBellScheduleComponent } from "./bell-schedule-setup/school-add-bell-schedule/school-add-bell-schedule.component";
import { SchoolEditBellScheduleComponent } from "./bell-schedule-setup/school-edit-bell-schedule/school-edit-bell-schedule.component";
import { DataService_BellScheduleSetup } from "./bell-schedule-setup/shared/data.service";
import { BellSchedulePeriodsComponent } from "./bell-schedule-setup/shared/bell-schedule-periods/bell-schedule-periods.component";
import { AddPeriodComponent } from "./bell-schedule-setup/shared/bell-schedule-periods/add-period/add-period.component";

//New Course Maintenance
import { CourseSetupComponent } from "./course-setup/course-setup.component";
import { DataService_CourseSetup } from "./course-setup/shared/data.service";

//New School Incident
import { SchoolIncidentTypeSetupComponent } from "./school-incident-type-setup/school-incident-type-setup.component";
import { SchoolAddSITypeComponent } from "./school-incident-type-setup/school-add-sitype/school-add-sitype.component";
import { SchoolEditSITypeComponent } from "./school-incident-type-setup/school-edit-sitype/school-edit-sitype.component";
import { DataService_SchoolIncidentTypeSetup } from "./school-incident-type-setup/shared/data.service";

//New PBIS Maintenance
import { PBISSetupComponent } from "./pbissetup/pbissetup.component";
import { SchoolAddMeritComponent } from "./pbissetup/school-add-merit/school-add-merit.component";
import { SchoolEditMeritComponent } from "./pbissetup/school-edit-merit/school-edit-merit.component";
import { DataService_PBISSetup } from "./pbissetup/shared/data.service";
import { PBISSchoolOrDistrictComponent } from "./pbissetup/shared/pbisschool-or-district/pbisschool-or-district.component";

//New Fine Type
import { FineTypeSetupComponent } from "./fine-type-setup/fine-type-setup.component";
import { DataService_FineTypeSetup } from "./fine-type-setup/shared/data.service";
import { AdminSetupAddFineTypeComponent } from "./fine-type-setup/admin-setup-add-fine-type/admin-setup-add-fine-type.component";
import { AdminSetupEditFineTypeComponent } from "./fine-type-setup/admin-setup-edit-fine-type/admin-setup-edit-fine-type.component";

//New Guardian Type
import { GuardianTypeSetupComponent } from "./guardian-type-setup/guardian-type-setup.component";
import { AddGuardianTypeComponent } from "./guardian-type-setup/add-guardian-type/add-guardian-type.component";
import { EditGuardianTypeComponent } from "./guardian-type-setup/edit-guardian-type/edit-guardian-type.component";
import { DataService_GuardianTypeSetup } from "./guardian-type-setup/shared/data.service";
import { PBISMaintenanceComponent } from "./pbismaintenance/pbismaintenance.component";
import { DataService_PBISMaintenance } from "./pbismaintenance/shared/data.service";
import { PointMaintAddComponent } from "./pbismaintenance/point-maint-add/point-maint-add.component";
import { PointMaintEditComponent } from "./pbismaintenance/point-maint-edit/point-maint-edit.component";
import { MealTypeMaintenanceComponent } from "./meal-type-maintenance/meal-type-maintenance.component";
import { LockerMaintenanceComponent } from "./locker-maintenance/locker-maintenance.component";
import { MealTypeModifyComponent } from "./meal-type-maintenance/meal-type-modify/meal-type-modify.component";
import { DataService_MealType } from "./meal-type-maintenance/shared/data.service";
import { SubsidyPricingTableComponent } from "./meal-type-maintenance/meal-type-modify/subsidy-pricing-table/subsidy-pricing-table.component";
import { LockerTableComponent } from "./locker-maintenance/locker-table/locker-table.component";
import { LockerHistoryTableComponent } from "./locker-maintenance/locker-history-table/locker-history-table.component";
import { DataService_Locker } from "./locker-maintenance/shared/data.service";
import { EditLockerComponent } from "./locker-maintenance/locker-table/edit-locker/edit-locker.component";
import { AddLockerComponent } from "./locker-maintenance/locker-table/add-locker/add-locker.component";
import { AssignLockersComponent } from "./locker-maintenance/locker-table/assign-lockers/assign-lockers.component";
import { ExportLockersComponent } from "./locker-maintenance/locker-table/export-lockers/export-lockers.component";
import { ImportLockersComponent } from "./locker-maintenance/locker-table/import-lockers/import-lockers.component";
import { AutoPBISSetupComponent } from "./auto-pbissetup/auto-pbissetup.component";
import { AutoPointTableComponent } from "./auto-pbissetup/auto-point-table/auto-point-table.component";
import { AutoPointSchoolTableComponent } from "./auto-pbissetup/auto-point-school-table/auto-point-school-table.component";
import { DataService_PBISAuto } from "./auto-pbissetup/shared/data.service";
import { AutoPointModifyComponent } from "./auto-pbissetup/auto-point-modify/auto-point-modify.component";
import { ScanStationReminderSetupComponent } from "./scan-station-reminder-setup/scan-station-reminder-setup.component";
import { ScanReminderTableComponent } from "./scan-station-reminder-setup/scan-reminder-table/scan-reminder-table.component";
import { ScanReminderPersonTableComponent } from "./scan-station-reminder-setup/scan-reminder-person-table/scan-reminder-person-table.component";
import { DataService_ReminderAlertSetup } from "./scan-station-reminder-setup/shared/data.service";
import { ScanReminderAddComponent } from "./scan-station-reminder-setup/scan-reminder-table/scan-reminder-add/scan-reminder-add.component";
import { ScanReminderEditComponent } from "./scan-station-reminder-setup/scan-reminder-table/scan-reminder-edit/scan-reminder-edit.component";
import { AddScanReminderPersonComponent } from "./scan-station-reminder-setup/scan-reminder-person-table/add-scan-reminder-person/add-scan-reminder-person.component";
import { ReminderStudentsToAddComponent } from "./scan-station-reminder-setup/scan-reminder-person-table/add-scan-reminder-person/reminder-students-to-add/reminder-students-to-add.component";
import { ScanReminderCopyComponent } from "./scan-station-reminder-setup/scan-reminder-table/scan-reminder-copy/scan-reminder-copy.component";
import { SetCalendarComponent } from "./calendarmaintenance/set-calendar/set-calendar.component";
import { BlockListSetupComponent } from "./block-list-setup/block-list-setup.component";
import { StationBlockAlertTableComponent } from "./block-list-setup/station-block-alert-table/station-block-alert-table.component";
import { StationBlockAlertAssignmentTableComponent } from "./block-list-setup/station-block-alert-assignment-table/station-block-alert-assignment-table.component";
import { AddStationBlockAlertComponent } from "./block-list-setup/station-block-alert-table/add-station-block-alert/add-station-block-alert.component";
import { UpdateStationBlockAlertComponent } from "./block-list-setup/station-block-alert-table/update-station-block-alert/update-station-block-alert.component";
import { DataService_BlockListSetup } from "./block-list-setup/shared/data.service";
import { SbaAddHomeroomComponent } from "./block-list-setup/station-block-alert-table/add-station-block-alert/sba-add-homeroom/sba-add-homeroom.component";
import { SbaAddGroupComponent } from "./block-list-setup/station-block-alert-table/add-station-block-alert/sba-add-group/sba-add-group.component";
import { SbaAddPersonComponent } from "./block-list-setup/station-block-alert-table/add-station-block-alert/sba-add-person/sba-add-person.component";
import { SBAssignmentAddGroupComponent } from "./block-list-setup/station-block-alert-assignment-table/sbassignment-add-group/sbassignment-add-group.component";
import { SBAssignmentAddHomeroomComponent } from "./block-list-setup/station-block-alert-assignment-table/sbassignment-add-homeroom/sbassignment-add-homeroom.component";
import { SBAssignmentAddStudentComponent } from "./block-list-setup/station-block-alert-assignment-table/sbassignment-add-student/sbassignment-add-student.component";
import { RoomSetupComponent } from "./room-setup/room-setup.component";
import { DataService_RoomSetup } from "./room-setup/shared/data.service";
import { AddRoomComponent } from './room-setup/add-room/add-room.component';
import { EditRoomComponent } from './room-setup/edit-room/edit-room.component';

@NgModule({
	declarations: [
		AdminSetupComponent,
		AcademySetupComponent,
		SchoolAddAcademyComponent,
		SchoolEditAcademyComponent,
		CommunicationMaintenanceComponent,
		AddNotificationComponent,
		AlertMaintenanceComponent,
		AddBroadcastAlertComponent,
		EditBroadcastAlertComponent,
		EditSpecialAlertComponent,
		AddEditEventAlertComponent,
		AddEditIncidentAlertComponent,
		ActionMaintenanceComponent,
		AddEditActionComponent,
		ActionMaintenanceSBTComponent,
		AddEditActionSBTComponent,
		InfractionMaintenanceComponent,
		AddEditInfractionComponent,
		InfractionMaintenanceSBTComponent,
		AddEditInfractionSBTComponent,
		SoundMaintenanceComponent,
		SchoolOrDistrictComponent,
		RecordSoundComponent,
		EditSoundComponent,
		CalendarmaintenanceComponent,
		CalendarEntryComponent,
		AdjustMenuComponent,
		ChangeMultipleComponent,
		ClassAttendanceExcuseSetupComponent,
		AdminSetupAddAttendanceExcuseComponent,
		AdminSetupEditAttendanceExcuseComponent,
		ExcuseSetupComponent,
		AdminSetupAddExcuseComponent,
		AdminSetupEditExcuseComponent,
		HomeroomSetupComponent,
		AdminSetupEditHomeroomComponent,
		SchoolDaySetupComponent,
		AdminSetupEditSchoolDayComponent,
		TimeScanTypeSetupComponent,
		AdminSetupAddTimeScanTypeComponent,
		AdminSetupEditTimeScanTypeComponent,
		BellScheduleSetupComponent,
		SchoolAddBellScheduleComponent,
		SchoolEditBellScheduleComponent,
		BellSchedulePeriodsComponent,
		AddPeriodComponent,
		CourseSetupComponent,
		SchoolIncidentTypeSetupComponent,
		SchoolAddSITypeComponent,
		SchoolEditSITypeComponent,
		PBISSetupComponent,
		SchoolAddMeritComponent,
		SchoolEditMeritComponent,
		PBISSchoolOrDistrictComponent,
		FineTypeSetupComponent,
		AdminSetupAddFineTypeComponent,
		AdminSetupEditFineTypeComponent,
		GuardianTypeSetupComponent,
		AddGuardianTypeComponent,
		EditGuardianTypeComponent,
		PBISMaintenanceComponent,
		PointMaintAddComponent,
		PointMaintEditComponent,
		MealTypeMaintenanceComponent,
		MealTypeModifyComponent,
		SubsidyPricingTableComponent,
		LockerMaintenanceComponent,
		LockerTableComponent,
		LockerHistoryTableComponent,
		EditLockerComponent,
		AddLockerComponent,
		AssignLockersComponent,
		ExportLockersComponent,
		ImportLockersComponent,
		AutoPBISSetupComponent,
		AutoPointTableComponent,
		AutoPointSchoolTableComponent,
		AutoPointModifyComponent,
		ScanStationReminderSetupComponent,
		ScanReminderTableComponent,
		ScanReminderPersonTableComponent,
		ScanReminderAddComponent,
		ScanReminderEditComponent,
		AddScanReminderPersonComponent,
		ReminderStudentsToAddComponent,
		ScanReminderCopyComponent,
		SetCalendarComponent,
		BlockListSetupComponent,
		StationBlockAlertTableComponent,
		StationBlockAlertAssignmentTableComponent,
		AddStationBlockAlertComponent,
		UpdateStationBlockAlertComponent,
		SbaAddHomeroomComponent,
		SbaAddGroupComponent,
		SbaAddPersonComponent,
		SBAssignmentAddGroupComponent,
		SBAssignmentAddHomeroomComponent,
		SBAssignmentAddStudentComponent,
		RoomSetupComponent,
  AddRoomComponent,
  EditRoomComponent,
	],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		RouterModule,
		BrowserAnimationsModule,
		BrowserModule,
		MatSlideToggleModule,
		DialogModule,
		ConfirmDialogModule,
		DynamicDialogModule,
		CalendarModule,
		TableModule,
		ButtonModule,
		MultiSelectModule,
		DropdownModule,
		InputNumberModule,
		RadioButtonModule,
		AccordionModule,
		FileUploadModule,
		CheckboxModule,
		AppSharedModule,
		PersonSelectorModule,
		ColorPickerModule,
		SchoolselectorModule,
		ListboxModule,
	],
	providers: [
		ConfirmationService,
		AdminSetupService,
		DataService_SoundMaintenance,
		DataService_AlertMaintenance,
		DataService_ActionMaintenance,
		DataService_ActionMaintenanceSBT,
		DataService_InfractionMaintenance,
		DataService_InfractionMaintenanceSBT,
		DataService_ClassAttendanceExcuseSetup,
		DataService_ExcuseSetup,
		DataService_HomeroomSetup,
		DataService_SchoolDaySetup,
		DataService_TimeScanTypeSetup,
		DataService_AcademySetup,
		DataService_BellScheduleSetup,
		DataService_CourseSetup,
		DataService_SchoolIncidentTypeSetup,
		DataService_PBISSetup,
		DataService_FineTypeSetup,
		DataService_GuardianTypeSetup,
		DataService_PBISMaintenance,
		DataService_MealType,
		DataService_Locker,
		DataService_PBISAuto,
		DataService_ReminderAlertSetup,
		DataService_BlockListSetup,
		DataService_RoomSetup,
	],
})
export class AdminSetupModule {}
